import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './css/CadastrarCertificado.css';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import CardNotification from '../components/CardNotification'; 

const CadastrarCertificado = () => {
    const [dataInicio, setDataInicio] = useState('');
    const [dataTermino, setDataTermino] = useState('');
    const [cargaHoraria, setCargaHoraria] = useState('');
    const [professor, setProfessor] = useState('');
    const [curso, setCurso] = useState('');
    const [modeloCertificado, setModeloCertificado] = useState('');
    const [alunosCSV, setAlunosCSV] = useState(null);
    const [disciplinasCSV, setDisciplinasCSV] = useState(null); 
    const [modelosExistentes, setModelosExistentes] = useState([]);
    const [statusMessage, setStatusMessage] = useState({ message: '', success: false });
    const [showCard, setShowCard] = useState(false);
    let id_instituicao = localStorage.getItem('id_instituicao');
    let id_usuario = localStorage.getItem('id_usuario');

    useEffect(() => {
        const fetchModelosExistentes = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/modelos/instituicao/${id_instituicao}`,{
                    withCredentials: true,
                });
                setModelosExistentes(response.data);
            } catch (error) {
                console.error('Erro ao buscar modelos existentes:', error);
                setStatusMessage({ message: 'Erro ao carregar modelos existentes.', success: false });
                setShowCard(true);
            }
        };
        fetchModelosExistentes();
    }, []);
    
    const handleFileUpload = (event, type) => {
        const file = event.target.files[0];
        if (file && (
            file.type === 'application/vnd.ms-excel' || 
            file.type === 'text/csv' || 
            file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        )) {
            if (type === 'alunos') {
                setAlunosCSV(file);
            } else if (type === 'disciplinas') {
                setDisciplinasCSV(file);
            }
        } else {
            setStatusMessage({ message: 'Por favor, envie um arquivo CSV ou Excel (.xlsx) válido.', success: false });
            setShowCard(true);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
    
        if (!alunosCSV || !disciplinasCSV) {
            setStatusMessage({ message: 'Por favor, selecione os arquivos CSV ou Excel para alunos e disciplinas.', success: false });
            setShowCard(true);
            return;
        }

    
        const formData = new FormData();
        formData.append("arquivo_1", alunosCSV); 
        formData.append("arquivo_2", disciplinasCSV); 
        formData.append("data_inicio", dataInicio);
        formData.append("data_fim", dataTermino);
        formData.append("carga_horaria", cargaHoraria);
        formData.append("professor", professor);
        formData.append("curso", curso);
        formData.append("id_modelo", modeloCertificado);
        formData.append('id_instituicao', id_instituicao);
        formData.append('id_usuario', id_usuario);
    
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/importar-certificados`,formData , {
                withCredentials: true,
                headers:{
                    "Content-Type": "multipart/form-data" 
                }
            });
            setStatusMessage({ message: 'Certififcados cadastrados!', success: true });
            setShowCard(true);
        } catch (error) {
            console.error("Erro ao cadastrar certificado:", error);
            setStatusMessage({ message: "Erro ao cadastrar certificado. Tente novamente.", success: false });
            setShowCard(true);
        }
    };
    

    useEffect(() => {
        if (showCard) {
            setTimeout(() => {
                setShowCard(false);
            }, 5000);
        }
    }, [showCard]);

    return (
        <div>
            <Header />
            <Sidebar />
            <div className="cadastrar-certificado-container">
                <h1>Cadastrar Certificado</h1>
                {statusMessage.message && showCard && (
                    <CardNotification 
                        message={statusMessage.message} 
                        type={statusMessage.success ? 'success' : 'error'} 
                        onClose={() => setShowCard(false)} 
                    />
                )}

                <form onSubmit={handleSubmit} className="cadastrar-certificado-form">
                    <div className="cadastrar-certificado-row-datas">
                        <div className="cadastrar-certificado-column">
                            <label className="cadastrar-certificado-label">Data de Início:</label>
                            <input type="date" value={dataInicio} onChange={(e) => setDataInicio(e.target.value)} required className="cadastrar-certificado-input" />
                        </div>
                        <div className="cadastrar-certificado-column">
                            <label className="cadastrar-certificado-label">Data de Término:</label>
                            <input type="date" value={dataTermino} onChange={(e) => setDataTermino(e.target.value)} required className="cadastrar-certificado-input" />
                        </div>
                    </div>
                    <div className="cadastrar-certificado-row">
                        <div className="cadastrar-certificado-column">
                            <label className="cadastrar-certificado-label">C.H (Carga Horária):</label>
                            <input type="number" value={cargaHoraria} onChange={(e) => setCargaHoraria(e.target.value)} required className="cadastrar-certificado-input" />
                        </div>
                        <div className="cadastrar-certificado-column">
                            <label className="cadastrar-certificado-label">Professor:</label>
                            <input type="text" value={professor} onChange={(e) => setProfessor(e.target.value)} required className="cadastrar-certificado-input" />
                        </div>
                    </div>
                    <div className="cadastrar-certificado-row">
                        <div className="cadastrar-certificado-column">
                            <label className="cadastrar-certificado-label">Curso:</label>
                            <input type="text" value={curso} onChange={(e) => setCurso(e.target.value)} required className="cadastrar-certificado-input" />
                        </div>
                        <div className="cadastrar-certificado-column">
                            <label className="cadastrar-certificado-label">Modelo de Certificado:</label>
                            <select value={modeloCertificado} onChange={(e) => setModeloCertificado(e.target.value)} required className="cadastrar-certificado-input">
                                <option value="">Selecione um modelo de certificado</option>
                                {modelosExistentes.map((modelo, index) => (
                                    <option key={modelo.id_modelo || index} value={modelo.id_modelo}>
                                        {modelo.nome_modelo}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    
                    <label className="cadastrar-certificado-label">
                        Lista de Alunos (Upload .xlsx):
                        <span className="file-format-note">Formato: CPF | Nome | Email | Telefone</span>
                    </label>
                    <input 
                        type="file" 
                        accept=".csv, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                        onChange={(e) => handleFileUpload(e, 'alunos')} 
                        required 
                        className="cadastrar-certificado-input" 
                    />
                    {alunosCSV && <p>{alunosCSV.name}</p>}
                    
                    <label className="cadastrar-certificado-label">
                        Lista de Disciplinas (Upload .xlsx):
                        <span className="file-format-note">Formato: Disciplina | Carga Horária</span>
                    </label>
                    <input 
                        type="file" 
                        accept=".csv, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                        onChange={(e) => handleFileUpload(e, 'disciplinas')} 
                        required 
                        className="cadastrar-certificado-input" 
                    />
                    {disciplinasCSV && <p>{disciplinasCSV.name}</p>}
                    
                    <button type="submit" className="cadastrar-certificado-button">Cadastrar Certificado</button>
                </form>
            </div>
        </div>
    );
};

export default CadastrarCertificado;
